import { render, staticRenderFns } from "./CoachStudentsTable.vue?vue&type=template&id=0f362e28&scoped=true"
import script from "./CoachStudentsTable.vue?vue&type=script&lang=js"
export * from "./CoachStudentsTable.vue?vue&type=script&lang=js"
import style0 from "./CoachStudentsTable.vue?vue&type=style&index=0&id=0f362e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f362e28",
  null
  
)

export default component.exports